import AttemptCell from './AttemptCell';
import ResultCell from './ResultCell';
import Col from '../../../components/Col';
import { Table } from '../../../components';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { groupBy, keyBy, mapValues, range } from 'lodash';

const AttemptCellsColGroup = ({ lift }) => (
  <colgroup>
    {range(1, lift.attemptCount + 1).map(number => (
      <Col key={number} width="5em" />
    ))}
    <Col width="5em" />
  </colgroup>
);

const AttemptCellsHeader1 = ({ lift }) => (
  <Table.HeaderCell key={lift.id} colSpan={lift.attemptCount + 1}>
    {lift.title}
  </Table.HeaderCell>
);

const AttemptCellsHeader2 = ({ lift }) => (
  <Fragment key={lift.id}>
    {range(1, lift.attemptCount + 1).map(number => (
      <Table.HeaderCell key={number}>{number}</Table.HeaderCell>
    ))}
    <Table.HeaderCell>=</Table.HeaderCell>
  </Fragment>
);

const AttemptCells = ({ row, lift, actions }) => {
  const { athlete } = row.meta;
  const attempts = athlete.attemptsByLiftId[lift.id];
  const attemptsByNumber = keyBy(attempts, 'number');

  const declarations = athlete.declarationsByLiftId[lift.id];
  const declarationsByNumber = groupBy(declarations, 'attemptNumber');

  const result = row.resultsByLiftId[lift.id];

  const styles = {
    1: { borderLeft: '1px solid black' },
    3: { borderRight: '1px solid black' },
  };

  const actionsByNumber = mapValues(
    keyBy(range(1, lift.attemptCount + 1)),
    number => ({
      declaration: ({ changeNumber, weight }) =>
        actions.declaration(athlete, lift, number, changeNumber, weight),
      decision: ({ weight, isGoodLift }) =>
        actions.decision(athlete, lift, number, weight, isGoodLift),
    }),
  );

  return (
    <Fragment>
      {range(1, lift.attemptCount + 1).map(number => (
        <AttemptCell
          key={number}
          title={`#${athlete.startNumber} / ${lift.abbreviation}${number}`}
          declarations={declarationsByNumber[number] || []}
          attempt={attemptsByNumber[number]}
          result={result}
          actions={actionsByNumber[number]}
          style={styles[number] || {}}
        />
      ))}
      <ResultCell lift={lift} result={result} />
    </Fragment>
  );
};

AttemptCells.ColGroup = AttemptCellsColGroup;
AttemptCells.Header1 = AttemptCellsHeader1;
AttemptCells.Header2 = AttemptCellsHeader2;

AttemptCells.propTypes = {
  row: PropTypes.shape({
    meta: PropTypes.shape({
      athlete: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  lift: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    declaration: PropTypes.func.isRequired,
    decision: PropTypes.func.isRequired,
  }).isRequired,
};

export default AttemptCells;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/AttemptCells.js